//
let urlStr = 'http://demo.rcapi.emof.cn/' //
// let urlStr = 'https://htjk.zexian.org.cn/' //
// let urlStr = 'https://htjk.zexian.org.cn/' //
// let urlStr = 'http://192.168.2.250:8008/' //


let downUrlStr = 'https://demo.rcapi.emof.cn/index/other/downLoadFile' //
let localAnStore = [
  {
    key: 'user',
    type: 'sessionStorage'
  }, // 用户名
  {
    key: 'selectionAddress',
    type: 'sessionStorage'
  } // 当前的选中城市
]
let defaultHeadImg = urlStr + '/' + 'uploads/images/user_defult.jpg'
let defaultHeadImg2 = urlStr + '/' + 'uploads/images/nv.png'
export default {
  urlStr,
  downUrlStr,
  localAnStore,
  defaultHeadImg, // 默认头像
  defaultHeadImg2 // 女
}
